import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { PlAPIConfig } from '../models';
import { PLCheckUserStatus, selectAuthState } from '../store';
import { PL_API_CONFIG } from '../tokens';

@Injectable({ providedIn: 'root' })
export class UserNotAuthenticatedGuard {
  constructor(
    @Inject(PL_API_CONFIG) config: PlAPIConfig,
    private store: Store,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(selectAuthState).pipe(
      mergeMap((authState) => {
        switch (authState) {
          case 'init':
            this.store.dispatch(PLCheckUserStatus({ lastActive: 0 }));
            return EMPTY;
          case 'error':
            return of(true);
          case 'success':
            return of(this.router.parseUrl('/'));
          case 'pending':
          default:
            return EMPTY;
        }
      }),
      first()
    );
  }
}
